module.exports = __webpack_public_path__ + "cdcd4a4d6729b563f6b3db32ac06978d.pdf";